import { useState } from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const DefaultLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (    
      <div className="flex h-screen overflow-hidden">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex flex-1 flex-col overflow-y-hidden overflow-x-hidden">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main className='bg-[#F4F6F9] p-3 sm:p-4 md:p-6 lg:p-8 flex-1 overflow-y-auto flex flex-col'>
            <div className="mx-auto w-full max-w-screen-2xl flex-1 flex flex-col">
              <Outlet />
            </div>
          </main>
        </div>
      </div>    
  );
};

export default DefaultLayout;